"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketAppIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.MarketAppIcon = (0, react_1.forwardRef)(function EatsAppIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("mask", { id: "mask0_1038_14361", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "36", height: "36" },
            react_1.default.createElement("path", { d: "M36 18C36 32.4039 32.4039 36 18 36C3.59606 36 0 32.4039 0 18C0 3.59606 3.59606 0 18 0C32.4039 0 36 3.59606 36 18Z", fill: "white" })),
        react_1.default.createElement("g", { mask: "url(#mask0_1038_14361)" },
            react_1.default.createElement("path", { d: "M0 0H36V36H0V0Z", fill: "#212121" }),
            react_1.default.createElement("path", { d: "M15.699 12.0447L9.17311 9.79442L9.15018e-05 21.8478L9.15881e-05 32.2563L9.44314 19.7855L8.27299 28.2919L14.8889 30.5422L22.7509 17.6876C22.3713 20.1195 21.7451 25.6258 27.1098 27.2467C30.2852 28.2061 33.2997 26.6131 36.0001 23.8568L36.0001 14.0739C33.3588 18.1049 30.7835 20.9949 29.444 20.6228C27.192 19.9972 29.2217 12.7172 30.5306 8.02225L30.551 7.94918L23.2306 5.47695L14.5288 19.7856L15.699 12.0447Z", fill: "#F5F4F2" }))));
});
